var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRwCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 19 26",
    fill: "none",
    preserveAspectRatio: "xMidYMid meet",
    "aria-hidden": "true",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.24074 1V3.37037M6.24074 22.3333V24.7037M10.9815 1V3.37037M10.9815 22.3333V24.7037M3.87037 3.37037H11.5741C14.1923 3.37037 16.3148 5.49287 16.3148 8.11111C16.3148 10.7293 14.1923 12.8519 11.5741 12.8519H3.87037H12.7593C15.3775 12.8519 17.5 14.9744 17.5 17.5926C17.5 20.2108 15.3775 22.3333 12.7593 22.3333H3.87037M3.87037 3.37037H1.5M3.87037 3.37037V22.3333M3.87037 22.3333H1.5",
    stroke: "url(#paint0_linear_1226_1824)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1226_1824",
    x1: 15.4995,
    y1: 8.99939,
    x2: 4.99988,
    y2: 16.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCF23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AD8B3A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRwCoin);
export default __webpack_public_path__ + "static/media/RWCoin.a0f1574242a6245ca12f89215c1e0e11.svg";
export { ForwardRef as ReactComponent };